import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { ROLE_PERMISSIONS } from '@worldathletics/utilities';

import { PageDefaultLayout } from '@/components/layout';
import { logout } from '@/context/store/slices/authSlice';
import { editorStore } from '@/context/store/store';

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    // Login redirects to /documents after authentication. Deep-link return
    // (preserve original URL so user lands on the page they were trying to
    // visit) is a Phase 1+ UX enhancement; for now, foundation only.
    const state = editorStore.getState().auth;
    if (state.status === 'force-change-password') {
      throw redirect({ to: '/force-change-password' });
    }
    if (state.status !== 'authenticated') {
      throw redirect({ to: '/login' });
    }
    // Roles with no web permissions (e.g. reader) are blocked from the web app.
    const role = state.user?.role;
    if (role && ROLE_PERMISSIONS[role].length === 0) {
      editorStore.dispatch(logout());
      throw redirect({ to: '/login', search: { error: 'access_denied' } });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <PageDefaultLayout>
      <Outlet />
    </PageDefaultLayout>
  );
}
